import { Text } from '@mantine/core';
import { PropsWithChildren } from 'react';

export default function Title({ children }: PropsWithChildren) {
  return (
    <Text size="xs" c="dimmed" mb="md">
      {children}
    </Text>
  );
}
